import { Component, OnInit } from '@angular/core';
import { EmailVerificationService } from '../../api/services/email-verification-service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  standalone: false,
})
export class EmailVerificationComponent implements OnInit {
  loading = true;
  hasError = false;

  constructor(
    private emailVerificationService: EmailVerificationService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    const userGuid = this.route.snapshot.queryParams['userGuid'];
    const token = this.route.snapshot.queryParams['code'];

    if (!userGuid || !token) {
      // If code or userGuid not present as query params, cannot process request, so show error
      this.loading = false;
      this.hasError = true;
    } else {
      // Try to validate email
      this.emailVerificationService
        .validateEmailVerificationToken({
          body: {
            userGuid: userGuid,
            token: token,
          },
        })
        .subscribe({
          next: () => {
            this.loading = false;
          },
          error: () => {
            this.loading = false;
            this.hasError = true;
          },
        });
    }
  }
}
